module.exports = __webpack_public_path__ + "static/media/WST2-NEW.3c23d93f.apng";